<template>
  <div class="content-wrap">
    <div class="card-header">
      <h3 class="title"></h3>
      <el-button
        type="primary"
        @click="handleToCreate"
      >添加评价</el-button>
    </div>
    <div class="table-wrap">
      <el-table
        :data="results"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          fixed="left"
        >
        </el-table-column>
        <el-table-column
          prop="user_nickname"
          label="用户信息"
          width="260"
          align="center"
        >
          <template slot-scope="scope">
            <div class="user-wrap">
              <img
                :src="scope.row.user_avatar"
                alt=""
                srcset=""
                style="width:24px;height:24px;margin-right:8px;border-radius:50%;"
              >
              <span>{{scope.row.user_nickname||scope.row.user_realname}}</span>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="用户评价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="缩略图"
          align="center"
          show-overflow-tooltip
        >
          <template
            slot-scope="scope"
            v-if="scope.row.content_file_urls"
          >
            <el-image
              v-for="(item,index) in scope.row.content_file_urls.split(',')"
              :key="index"
              style="max-height:40px;height:40px;padding:-8px 0px;margin:0px 8px;"
              :src="item"
              @click="openViewer(item)"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="审核状态"
          align="center"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">
            <el-tag
              type="warning"
              size="mini"
              v-if="scope.row.check_status==0"
            >待审核</el-tag>
            <el-tag
              type="success"
              size="mini"
              v-if="scope.row.check_status==1"
            >已通过</el-tag>
            <el-tag
              type="danger"
              size="mini"
              v-if="scope.row.check_status==2"
            >已拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="like_real_count"
          label="点赞量"
          align="center"
          show-overflow-tooltip
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="发布时间"
          width="150"
        >
          <template slot-scope="scope">
            {{scope.row.publish_time?$moment(scope.row.publish_time).format("YYYY-MM-DD HH:mm:ss"):""}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="排序值"
          width="80"
        >
          <template slot-scope="scope">
            {{scope.row.sort}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200"
          show-overflow-tooltip
          fixed="right"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.check_status==1">
              <!--            <el-link
                type="primary"
                :underline="false"
                @click="handleSortChange(scope.$index,'up')"
                v-if="scope.$index!=0"
              >上移</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="handleSortChange(scope.$index,'dwon')"
                v-if="scope.$index!=results.length-1"
              >下移</el-link> -->
              <el-link
                type="primary"
                :underline="false"
                @click="handleToEdit(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row.id)"
              >删除</el-link>
            </div>
            <div v-if="scope.row.check_status==0">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToEditStatus(scope.row,1,'确定要通过审核吗')"
              >通过</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToEditStatus(scope.row,2,'确定要拒绝审核吗')"
              >拒绝</el-link>
            </div>
            <div v-if="scope.row.check_status==2">
              <el-link
                type="danger"
                :underline="false"
                disabled
              >已拒绝</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="action-wrap">
        <div>
          <el-button
            size="mini"
            type="danger"
            @click="handleToDeleteAll()"
          >批量删除</el-button>
        </div>
      </div>
    </div>
    <CommentCreate
      :isVisible="createDialog"
      @close="createDialog=false"
      @submit="getList()"
      :product_id="this.$route.params.courseId"
    />
    <CommentEdit
      :isVisible="editDialog"
      @close="editDialog=false"
      @submit="getList()"
      :id="editId"
    />
    <el-image-viewer
      v-if="showViewer"
      :url-list="tableImg"
      :on-close="closeViewer"
    />
  </div>
</template>

<script>
import { appraiselist, productappraiseDestroy, productappraiselistDestroy, productappraiseUpdate } from "@/api/product";
import CommentCreate from "@/components/dialog/product/CommentCreate.vue";
import CommentEdit from "@/components/dialog/product/CommentEdit.vue";

// 导入组件
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    CommentCreate,
    CommentEdit,
    ElImageViewer,

  },
  data() {
    return {
      chooseList: [],
      results: [],
      query: {
        product_id: this.$route.params.courseId
      },
      createDialog: false,
      editDialog: false,
      editId: null,
      tableImg: [],
      showViewer: false,
    };
  },
  created() {

  },
  mounted() {
    this.getList()
  },
  computed: {

  },
  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    getList() {
      const params = Object.assign({}, this.query);
      appraiselist(params).then((res) => {
        console.log(res);
        this.results = res.list
      });
    },
    handleToCreate() {
      this.createDialog = true
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    handleToRemove(id) {
      this.$confirm("确定要删除此条评价吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        productappraiseDestroy({ id }).then((res) => {
          this.$nextTick(() => {
            this.getList();
          });
        });
      })
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm("确定要删除这些信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.chooseList.map(v => { return v.id })
        productappraiselistDestroy({ ids }).then((res) => {
          this.getList(this.query);
        });
      })
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    openViewer(url) {
      this.tableImg = [url];
      this.showViewer = true;
    },
    handleToEditStatus(row, status, text) {
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          id: row.id,
          check_status: status,
        }
        productappraiseUpdate(data).then((res) => {
          this.getList(this.query);
        });
      })
    },
    // 排序选项
    handleSortChange(index, type) {
      var rows = this.results[index]
      if (type == "up") {
        var sort = Number(rows.sort) - 1
        var rows_other = this.results[index - 1]
        var sort_other = Number(rows_other.sort) + 1
      } else if (type == "down") {
        var sort = Number(rows.sort) + 1
        var rows_other = this.results[index + 1]
        var sort_other = Number(rows_other.sort) - 1
      }
      productappraiseUpdate({
        id: rows.id,
        sort: sort
      }).then((res) => {
        productappraiseUpdate({
          id: rows_other.id,
          sort: sort_other
        }).then((res1) => {
          this.getList(this.query);

        });
      });
    },
  }
};
</script>

<style lang="less" scoped>
.content-wrap {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  .table-wrap {
    .user-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .action-wrap {
    margin-top: 16px;
  }
}
.el-link {
  font-size: 12px;
  margin: 5px;
}
</style>
